import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';
@Component({
  selector: 'app-team-weekly-slot-card',
  templateUrl: './team-weekly-slot-card.component.html',
  styleUrls: ['./team-weekly-slot-card.component.scss']
})
export class TeamWeeklySlotCardComponent implements OnInit {
  @Input() teamShiftDetail: any;
  @Input() isOpenShiftPermission = false;
  @Input() providerId: any;
  @Input() id: any;
  @Input() isPastDate: any;
  @Output() openShiftPopup = new EventEmitter();
  // teamAvailabilityStatusColor = AppSettings.TEAM_AVAILABILITY_STATUS;
  teamShiftStatusColor = AppSettings.TEAM_SHIFT_STATUS;
  bgCardClass = '';
  borderClass = '';
  teamSlots = [];
  displayingTeamSlot = [];
  date: any;
  minDate = new Date();
  organizationLevelDispatch = false;
  providerLevelDutyFlag = false;
  teamLevelDutyFlag = false;
  organizationLevelDispatchFlexible: Boolean = false;
  providerLevelDutyFlagFlexible: Boolean = false;
  teamLevelDutyFlagFlexible = false;
  globalConfigOS = false;

  constructor(private router: Router, private manageOpenShiftService: ManageOpenShiftsService,
    private commonService: CommonBindingDataService
  ) { }

  ngOnInit(): void {
    this.date = new Date(this.teamShiftDetail.dateStr || this.minDate);
    this.displayingTeamSlot =  this.teamShiftDetail.teamShiftMembers;
    if (this.teamShiftDetail.teamShiftMembers.length > 1) {
      const scheduleLength = this.teamShiftDetail.teamShiftMembers[0].shiftMemberSchedules.length +
        this.teamShiftDetail.teamShiftMembers[1].shiftMemberSchedules.length;
      if (scheduleLength > 3) {
        this.teamSlots = this.teamShiftDetail.teamShiftMembers.slice(1);
        this.displayingTeamSlot = this.teamShiftDetail.teamShiftMembers.slice(0, 1);
      } else if (this.teamShiftDetail.teamShiftMembers.length > 2) {
        this.teamSlots = this.teamShiftDetail.teamShiftMembers.slice(2);
        this.displayingTeamSlot = this.teamShiftDetail.teamShiftMembers.slice(0, 2);
      }
    }
    this.bgCardClass =  this.manageOpenShiftService.convertToCssClass(this.teamShiftDetail?.teamStatus);
    this.borderClass = this.teamShiftStatusColor[this.teamShiftDetail?.openShiftRequestStatus] || '';

    this.organizationLevelDispatch = this.commonService.getGlobalConfigByKey(AppSettings.DISPATCH_LEVEL_DUTY_ON_OFF)?.value;
    this.providerLevelDutyFlag = this.commonService.checkForGlobalConfigDOOPL(
      AppSettings.GLOBAL_CONFIGRATION.PROVIDER_LVL, this.providerId);
    this.teamLevelDutyFlag = this.commonService.checkConfigDOOTeamLevel(AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL, this.id);
    this.organizationLevelDispatchFlexible = this.commonService.getGlobalConfigByKey(
      AppSettings.GLOBAL_CONFIGRATION.ORGANIZATION_FLEX_SHIFT)?.value;
    this.providerLevelDutyFlagFlexible = this.commonService.checkForGlobalConfigDOOPL(
      AppSettings.GLOBAL_CONFIGRATION.PROVIDER_LVL_FLEX_SHIFT, this.providerId);
    this.teamLevelDutyFlagFlexible = this.commonService.checkConfigDOOTeamLevel(
      AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL_FLEX_SHIFT, this.id);
    this.globalConfigOS = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.OPEN_SHIFT)?.value;

  }

  goToEdit(date) {
    this.router.navigate(['hc-providers/edit-teams'], { queryParams: { id: this.id, providerId: this.providerId }, state: { date } });
  }

  openShift() {
    const teamDetails = {
      date: this.teamShiftDetail.dateStr,
      teamName: this.id
    };
    this.openShiftPopup.emit(teamDetails);
  }

  setNotAvailableFlag(shiftMemberSchedule) {
    if (!shiftMemberSchedule) {
      return false;
    }
    if (shiftMemberSchedule.length === 0) {
      return true;
    }
    return shiftMemberSchedule.every((team) => team.startTimeStr === null && team.endTimeStr === null);
  }

}
